import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { BrandColors } from '../../constants/brandColors';
import { hexToRgba } from '../../generalContent/utils/generalContent';

export const RaterStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      '& #root > footer, #root > .icp-recordal-footer, #root > header > div > button,  #root > header > div > div:nth-child(2)': {
        display: 'none',
      },
      '& #root > header': {
        background: theme.palette.headerColor?.main,
      },
      '& #root > .main-content': {
        background: theme.palette.background.default,
        minHeight: 'calc(100vh -  2.5rem)',
        overflow: 'hidden',
        [theme.breakpoints.up('md')]: {
          minHeight: 'calc(100vh -  3.125rem)',
        },
      },
    },
    raterContainer: {
      margin: 'auto',
      minWidth: '17.5rem',
      [theme.breakpoints.up('sm')]: {
        maxWidth: '43.75rem',
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: '38rem',
      },
      [theme.breakpoints.down('xs')]: {
        maxWidth: '21.125rem',
      },
      [theme.breakpoints.down(375)]: {
        maxWidth: '17.5rem',
      },
    },
    raterContainerHelp: {
      '& #root > footer, #root > .icp-recordal-footer, #root > header > div > button,  #root > header > div > div:nth-child(2)': {
        display: 'none',
      },
      '& #root > header': {
        background: theme.palette.headerColor?.main,
      },
      '& #root > .main-content': {
        background: theme.palette.background.default,
        minHeight: 'calc(100vh -  2.5rem)',
        overflow: 'hidden',
        [theme.breakpoints.up('md')]: {
          minHeight: 'calc(100vh -  3.125rem)',
        },
      },
      background: theme.palette.primary.main,
    },
    raterCard: {
      border: `0.031rem solid ${BrandColors.grey89}`,
      boxSizing: 'border-box',
      boxShadow: `0px 0.25rem 0.25rem ${BrandColors.blackWithOpacity25}`,
      borderRadius: '0.5rem',
      marginTop: '1.25rem',
      marginBottom: '1.25rem',
    },
    raterCardContent: {
      padding: '0 !important',
    },
    raterCardHeader: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-evenly',
      alignItems: 'center',
    },
    cardDivider: {
      borderBottom: `1px solid ${BrandColors.blackWithOpacity20}`,
    },
    paddingTop12: {
      paddingTop: '0.75rem',
    },
    paddingTopLeftRight: {
      paddingTop: '0.75rem',
      paddingLeft: '0.5rem',
      paddingRight: '0.5rem',
    },
    paddingTopBottom: {
      paddingTop: '1rem',
      paddingBottom: '1rem',
    },
    textAlignLeft: {
      textAlign: 'left',
    },
    textAlignRight: {
      textAlign: 'right',
    },
    paddingLeftRight8: {
      padding: '0 0.5rem',
    },
    padding4: {
      padding: '0.5rem 0.1rem !important',
    },
    pageTitle: {
      fontWeight: 'bold',
      fontSize: '1.125rem',
      lineHeight: '1.5rem',
      color: BrandColors.grey30,
      outline: 'none',
      flexGrow: 1,
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.5rem',
        lineHeight: '1.75rem',
        marginTop: '4.875rem',
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: '1.75rem',
      },
    },
    margin5: {
      marginLeft: '5rem',
    },
    pageSubTitle: {
      fontWeight: 'bold',
      fontSize: '1rem',
      lineHeight: '1.375rem',
      color: BrandColors.grey30,
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.125rem',
        lineHeight: '1.25rem',
        paddingTop: '1.25rem',
      },
      [theme.breakpoints.down('sm')]: {
        paddingTop: '0.688rem',
      },
    },
    pageSubTitle2: {
      fontWeight: 600,
      fontSize: '0.625rem',
      lineHeight: '0.875rem',
      color: BrandColors.grey30,
      [theme.breakpoints.up('sm')]: {
        fontSize: '0.875rem',
        lineHeight: '1.188rem',
        paddingTop: '0.625rem',
      },
    },
    raterCardTitle: {
      fontWeight: 600,
      fontSize: '0.875rem',
      lineHeight: '1.188rem',
      color: BrandColors.blackPearl,
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.125rem',
        lineHeight: '1.563rem',
        paddingRight: '2rem',
      },
    },
    raterCardSubTitle: {
      fontWeight: 'normal',
      fontSize: '0.75rem',
      lineHeight: '1rem',
      color: BrandColors.grey41,
      [theme.breakpoints.up('sm')]: {
        fontSize: '0.875rem',
        lineHeight: '1.188rem',
      },
      [theme.breakpoints.down('sm')]: {
        width: '80%',
      },
    },
    raterCardSmWidth100: {
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    searchDivider: { width: '100%', marginTop: '1.5rem', marginBottom: '1.5rem', gridColumnStart: 1, gridColumnEnd: 3 },
    searchForm: {
      display: 'flex',
      gridTemplateColumns: '50% 50%',
      '@media screen and (-ms-high-contrast: none)': {
        display: 'flex !important',
      },
      [theme.breakpoints.up('sm')]: {
        display: 'grid',
      },
    },
    searchFields: {
      '@media screen and (-ms-high-contrast: none)': {
        flex: 50,
      },
    },
    marginTop1: {
      marginTop: '1rem',
    },
    expandicon: {
      height: '1.5rem',
      width: '1.5rem',
      marginRight: '2rem',
    },
    raterName: {
      fontWeight: 'normal',
      fontSize: '0.75rem',
      lineHeight: '1rem',
      color: BrandColors.grey35,
      [theme.breakpoints.up('sm')]: {
        fontSize: '1rem',
        lineHeight: '1.375rem',
      },
    },
    raterActionButtons: {
      fontWeight: 'normal',
      fontSize: '0.75rem',
      lineHeight: '1rem',
      color: BrandColors.link,
      width: '1.5rem',
      height: '1rem',
      textTransform: 'none',
      textDecoration: 'underline',
      [theme.breakpoints.up('sm')]: {
        fontSize: '0.875rem',
        lineHeight: '0.313rem',
        width: '1.813rem',
      },
    },
    addButton: {
      fontSize: '0.813rem',
      lineHeight: '0.625rem',
      letterSpacing: '0.15em',
      height: '1.5rem',
      minWidth: '3.875rem',
      width: 'auto',
      float: 'right',
      borderRadius: '2rem',
      marginLeft: 0,
      background: theme.palette.primary.main,
      color: theme.palette.background.paper,
      textTransform: 'uppercase',
      '&:hover': {
        border: '2px solid',
        background: theme.palette.background.paper,
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
      },
      '&:disabled': {
        background: BrandColors.grey99,
        color: BrandColors.grey100,
        borderColor: BrandColors.grey99,
      },
      [theme.breakpoints.up('sm')]: {
        '@media screen and (-ms-high-contrast: none)': {
          padding: '0',
        },
        padding: '0.438rem 1.625rem',
      },
    },
    addFeedbackProviderLink: {
      textDecoration: 'underline',
      color: theme.palette.text.secondary,
      [theme.breakpoints.down('xs')]: {
        margin: '1.5rem 0',
      },
      [theme.breakpoints.up('sm')]: {
        flexGrow: '1',
        padding: '0.5rem',
      },
    },
    noSearchResultsLink: {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    width100: {
      width: '6.25rem',
    },
    width118: {
      width: '7.375rem',
    },
    doneButton: {
      fontSize: '0.8125rem',
      lineHeight: '1.3125rem',
      letterSpacing: '0.15em',
      height: '2.5rem',
      width: 'auto',
      minWidth: '7rem',
      borderRadius: '2rem',
      border: '2px solid',
      marginLeft: 0,
      background: theme.palette.background.paper,
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
      textTransform: 'uppercase',
      '&:hover': {
        border: '2px solid',
        background: theme.palette.primary.main,
        borderColor: theme.palette.background.paper,
        color: theme.palette.background.paper,
      },
      '&:disabled': {
        background: BrandColors.white,
        color: BrandColors.grey80,
        borderColor: BrandColors.white,
      },
      [theme.breakpoints.up('sm')]: {
        padding: '0.438rem 0.625rem',
      },
    },
    circleTickColor: {
      fill: theme.palette.primary.main,
    },
    raterNominationNote: {
      position: 'relative',
      '& > div': {
        backgroundColor: theme.palette.primary.main,
        borderRadius: '4px',
        boxShadow: `6px 6px 8px ${BrandColors.blackWithOpacity25}`,
        '& p': {
          fontWeight: 600,
          fontSize: '0.875rem',
          lineHeight: '1.188rem',
          color: BrandColors.white,
        },
        '&::after': {
          content: '" "',
          position: 'absolute',
          top: '100%' /* At the bottom of the tooltip */,
          left: '90%',
          border: '14px solid',
          borderColor: `${theme.palette.primary.main} transparent transparent transparent`,
        },
      },
    },
    pointer: {
      cursor: 'pointer',
    },
    bgWhite: {
      backgroundColor: BrandColors.white,
    },
    marginTop0: {
      marginTop: 0,
    },
    marginTopPaddingRightLeft: {
      marginTop: '0.75rem',
      paddingLeft: '0.5rem',
      paddingRight: '0.5rem',
    },
    noMargin: {
      margin: 0,
    },
    errorMsgCenter: {
      '& > div': {
        justifyContent: 'center',
      },
    },
    pagination: {
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        '& > p': {
          marginBottom: '0.75rem',
        },
        '& > nav > ul': {
          justifyContent: 'center',
        },
      },
      [theme.breakpoints.up('sm')]: {
        display: 'flex',
        justifyContent: 'space-between',
      },
    },
    alertBox: {
      width: 'inherit',
      paddingBottom: '1rem',
    },
    highlight: {
      backgroundColor: hexToRgba(theme.palette.primary.main, 20),
    },
    fullWidth: { width: '100%' },
    inlineFlex: { display: 'inline-flex' },
    helpButton: {
      height: '100%',
      alignSelf: 'flex-end',
      marginBottom: '-0.5rem',
    },
    helpIcon: { height: '27px', width: '27px' },
  }),
);
